<nav
  class="navbar navbar-expand-lg navbar-light"
  [class]="tenant === 'sdv' ? 'bg-sdv' : 'bg-light'"
>
  <div class="container-fluid justify-content-end">
    <!-- Home / Brand Button -->
    <a class="navbar-brand cursor-pointer">
      <ng-container [ngSwitch]="tenant">
        <h1
          class="fw-bold text-uppercase mb-0"
          *ngSwitchCase="'default'"
          routerLink="home"
          [class.app-title-mobile]="isHandset$ | async"
        >
          {{
            'title.' + tenant + '.application' | translate
          }}
        </h1>
        <div
          *ngSwitchCase="'sdv'"
          class="logo"
          routerLink="home"
        >
          <img
            class="sdv"
            src="/assets/img/logos/sdv-logo-sw.png"
            [alt]="'title.sdv.logo' | translate"
          />
        </div>
      </ng-container>
    </a>

    <!-- Toggler -->
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Collapsible Content -->
    <div
      class="collapse navbar-collapse justify-content-end"
      id="navbarNav"
    >
      <ul class="navbar-nav">
        <li
          class="nav-item d-flex align-items-center"
          *ngIf="containsLinks"
        >
          <a
            class="nav-link fw-bold text-primary"
            [routerLink]="['/home/registrations']"
            routerLinkActive="active"
            attr.data-text="{{
              'title.my-registrations' | translate
            }}"
          >
            {{ 'title.my-registrations' | translate }}
          </a>
        </li>
        <li
          class="nav-item d-flex align-items-center"
          *ngIf="containsLinks"
        >
          <a
            class="nav-link fw-bold text-primary"
            [routerLink]="['/home/bookings']"
            routerLinkActive="active"
            attr.data-text="{{
              'title.bookings' | translate
            }}"
          >
            {{ 'title.bookings' | translate }}
          </a>
        </li>

        <ng-container *ngIf="containsLinks && isAdmin">
          <li class="nav-item d-flex align-items-center">
            <a
              class="nav-link fw-bold text-primary"
              [routerLink]="['/home/user']"
              routerLinkActive="active"
              attr.data-text="{{
                'label.user-list' | translate
              }}"
            >
              {{ 'label.user-list' | translate }}
            </a>
          </li>
          <li class="nav-item d-flex align-items-center">
            <a
              class="nav-link fw-bold text-primary"
              [routerLink]="['/home/exam']"
              routerLinkActive="active"
              attr.data-text="{{
                'label.exams.exam-list' | translate
              }}"
            >
              {{ 'label.exams.exam-list' | translate }}
            </a>
          </li>
          <li class="nav-item d-flex align-items-center">
            <a
              class="nav-link fw-bold text-primary"
              [routerLink]="['/home/exam-location']"
              routerLinkActive="active"
              attr.data-text="{{
                'label.exam-location.list' | translate
              }}"
            >
              {{ 'label.exam-location.list' | translate }}
            </a>
          </li>
          <li class="nav-item d-flex align-items-center">
            <a
              class="nav-link fw-bold text-primary"
              [routerLink]="['/home/university']"
              routerLinkActive="active"
              attr.data-text="{{
                'label.university.list' | translate
              }}"
            >
              {{ 'label.university.list' | translate }}
            </a>
          </li>
          <li class="nav-item d-flex align-items-center">
            <a
              class="nav-link fw-bold text-primary"
              [routerLink]="['/home/exam-center']"
              routerLinkActive="active"
              attr.data-text="{{
                'label.exam-center-list' | translate
              }}"
            >
              {{ 'label.exam-center-list' | translate }}
            </a>
          </li>
        </ng-container>

        <li
          class="nav-item d-flex align-items-center"
          *ngIf="tenant === 'default'"
        >
          <a class="nav-link">
            <app-i18n-button></app-i18n-button>
          </a>
        </li>

        <li class="nav-item d-flex align-items-center">
          <a class="nav-link">
            <app-profile-button></app-profile-button>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
